/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { useSelector } from 'react-redux';

import { ConversionApiMeta, getFbc, getFbp } from '~/functions/meta';

import { ConversionApiTiktok, getTtclid, getTtp } from '~/functions/tiktok';
import api from '~/services/api';
// import { getVstId } from '~/functions/tracking';
import ImageIcon from '../../../assets/icons/paymentsuccess/image.svg';

import { Container } from './styles';

function PaymentSuccess() {
  const uuid = uuidv4();

  const { id, email, whatsapp } = useSelector(
    state => state.user && state.user.profile && state.user.profile
  );
  const injectGA = () => {
    if (typeof window === 'undefined') {
      return;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());

    // gtag('config', 'AW-491873348');
    // gtag('event', 'conversion', {
    //   send_to: 'AW-491873348/unLrCP7Jo9kCEMTIxeoB',
    // });

    gtag('event', 'conversion', {
      send_to: 'AW-17728141292/DfwHCJP7y78bEOzvt4VC',
      value: 30.0,
      currency: 'BRL',
      transaction_id: '',
    });

    gtag('event', 'success_payment_page_btn', {
      debug_mode: false,
    });
  };

  useEffect(() => {
    async function load() {
      const userregistrationtracking = await api.get(
        '/userregistrationtracking'
      );

      // const vst_id = await getVstId(userregistrationtracking);
      const fbc = await getFbc(userregistrationtracking);
      const fbp = await getFbp(userregistrationtracking);
      const ttclid = await getTtclid(userregistrationtracking);
      const ttp = await getTtp(userregistrationtracking);

      try {
        ConversionApiMeta({
          eventName: 'Subscribe',
          eventId: uuid,
          email,
          phone: whatsapp,
          externalId: id,
          fbc,
          fbp,
        });
      } catch (err) {
        console.log('Erro ao enviar Subscribe Meta', err);
      }

      try {
        ConversionApiTiktok({
          eventName: 'Purchase',
          eventId: uuid,
          email,
          phone: whatsapp,
          externalId: id,
          ttclid,
          ttp,
        });
      } catch (err) {
        console.log('Erro ao enviar Purchase Tiktok', err);
      }
    }

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <script>{injectGA()}</script>
      <div>
        <img src={ImageIcon} alt="icon" />
        <h2>Parabéns</h2>
        <strong>Sua assinatura foi concluída 🎉</strong>

        <Link to="/">Voltar para o dashboard</Link>
      </div>
    </Container>
  );
}

export default PaymentSuccess;
